

export const environment = {
  appVersion: "8.4.12",
  production: true
  ,API_ENDPOINT:'api'
  ,API_UPLOAD_ENDPOINT: 'api/uploads'
  ,gis_configuration:{
    gis_server_url:"https://esolar-gis.geoaitech.com"
    ,gis_base_service_raster_url:"/map/service"
    ,gis_base_service_vector_url:"/cgi-bin/wfs"    
    ,layers: {
      hd_base_layer: "Geoaitech",
      site_panels: "Geoaitech_Panels",
      site_boundary: "eSolar_Sites",
      supervision_images: "Geoaitech_SupervisionImage"
    }    
  }
  ,user_test:''
  ,user_pwd:''
  ,issueimagebasedir:''
  ,debuglist:[{key:"IssueEdit2Component",debug:true}]
  ,opermaintdemo:true
  ,debuglevel:2
};